import {QuestionAnswersCount, QuestionReport, LiveRoomReportDTO} from '../../../incase-domain/analytics';
import {ISlidesAnalytics} from '../../../incase-domain/proptypes/slidesAnalytics';

export const CREATE_SLIDES_ANALYTICS = 'CREATE_SLIDES_ANALYTICS';
export const UPDATE_ANALYTICS_DATA = 'UPDATE_ANALYTICS_DATA';
export const FETCH_ANALYTICS_DATA = 'FETCH_ANALYTICS_DATA';
export const FETCH_QUESTION_REPORT = 'FETCH_QUESTION_REPORT';
export const UPDATE_QUESTION_REPORT = 'UPDATE_QUESTION_REPORT';
export const FETCH_SLIDES_ANALYTICS = 'FETCH_SLIDES_ANALYTICS';
export const UPDATE_SLIDES_ANALYTICS = 'UPDATE_SLIDES_ANALYTICS';
export const UPDATE_SLIDES_ANALYTICS_UPDATE_TIME = 'UPDATE_SLIDES_ANALYTICS_UPDATE_TIME';
export const FETCH_QUESTION_ANSWERS_COUNT = 'FETCH_QUESTION_ANSWERS_COUNT';
export const UPDATE_QUESTION_ANSWERS_COUNT = 'UPDATE_QUESTION_ANSWERS_COUNT';
export const UPDATE_LIVE_ROOM_REPORT = 'UPDATE_LIVE_ROOM_REPORT';

export interface ICreateSlidesAnalyticsActionType {
    type: typeof CREATE_SLIDES_ANALYTICS;
    payload: {runFileId: string; presentationId: string};
}

export interface IFetchAnalyticsDataActionType {
    type: typeof FETCH_ANALYTICS_DATA;
    searchForm: {id: string};
}

export interface IUpdateAnalyticsDataActionType {
    type: typeof UPDATE_ANALYTICS_DATA;
    analyticsData: [];
}

export interface IFetchQuestionReportActionType {
    type: typeof FETCH_QUESTION_REPORT;
    elementId: string;
    roomRunfileId?: string;
}

export interface IUpdateQuestionReportActionType {
    type: typeof UPDATE_QUESTION_REPORT;
    questionReport: QuestionReport;
}

export interface IFetchSlidesAnalyticsActionType {
    type: typeof FETCH_SLIDES_ANALYTICS;
    runfileId: string;
}

export interface IUpdateSlidesAnalyticsActionType {
    type: typeof UPDATE_SLIDES_ANALYTICS;
    slidesAnalytics: ISlidesAnalytics;
}

export interface IUpdateSlidesAnalyticsTimeActionType {
    type: typeof UPDATE_SLIDES_ANALYTICS_UPDATE_TIME;
    time: number;
}

export interface IFetchQuestionAnswersCountActionType {
    type: typeof FETCH_QUESTION_ANSWERS_COUNT;
    elementId: string;
    roomId: string;
    roomRunFileId: string;
}

export interface IUpdateQuestionAnswersCountActionType {
    type: typeof UPDATE_QUESTION_ANSWERS_COUNT;
    questionAnswersCount: QuestionAnswersCount;
}

export interface IUpdateLiveRoomReportActionType {
    type: typeof UPDATE_LIVE_ROOM_REPORT;
    liveRoomReport: LiveRoomReportDTO;
}

export type AnalyticsReducerType =
    | ICreateSlidesAnalyticsActionType
    | IUpdateAnalyticsDataActionType
    | IFetchAnalyticsDataActionType
    | IFetchQuestionReportActionType
    | IFetchSlidesAnalyticsActionType
    | IUpdateSlidesAnalyticsActionType
    | IUpdateQuestionReportActionType
    | IFetchQuestionAnswersCountActionType
    | IUpdateQuestionAnswersCountActionType
    | IUpdateLiveRoomReportActionType;
